import {
  Autocomplete,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  styled,
  Select,
  MenuItem,
} from "@mui/material";
import { SimpleCard } from "app/components";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import React from "react";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import { useState } from "react";
import { useEffect, useRef } from "react";
import {
  attendanceConvertedDate,
  convertedDateToMonthyearFormat,
  convertedDate,
  errorMessage,
  errorMessage2,
  formateDisplayDate,
  EmpCard,
  convertedDateToMonthyearFormat2,
  currentDate,
} from "app/utils/utils";
import { baseURL } from "app/Api/axios";
import { generateErrorMessage } from "app/utils/GenerateMessage";
import { searchReport,getAllCompanyConfig  } from "app/services/Services";
import { useLocation, useNavigate } from "react-router-dom";
import useEmpList from "app/hooks/useEmpList";
import CloseIcon from "@mui/icons-material/Close";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import AdminComplianceHeader from "app/components/AdminComplianceHeader";
import BackdropLoader from "app/components/BackdropLoader";
import moment from "moment";

const Container = styled("div")(({ theme }) => ({
  // margin: "30px",
  // margin: "30px",
  [theme.breakpoints.down("sm")]: { margin: "16px" },
  "& .breadcrumb": {
    marginBottom: "30px",
    [theme.breakpoints.down("sm")]: { marginBottom: "16px" },
  },
}));
const CardHeader = styled(Box)(() => ({
  display: "flex",
  paddingLeft: "24px",
  paddingRight: "24px",
  marginBottom: "12px",
  alignItems: "center",
  justifyContent: "right",
}));
const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1),
}));
const StyledTable = styled(Table)(() => ({
  whiteSpace: "pre",
  "& thead": {
    "& tr": { "& th": { paddingLeft: 0, paddingRight: 0 } },
  },
  "& tbody": {
    "& tr": { "& td": { paddingLeft: 0, textTransform: "capitalize" } },
  },
}));
const Title = styled("span")(() => ({
  fontSize: "1.2rem",
  fontWeight: "600",
  textTransform: "capitalize",
}));
const AutoComplete = styled(Autocomplete)(() => ({
  width: "85%",
}));
const Report = () => {
  const state = useEmpList();
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const pageQuery = query.get("page") ? Number(query.get("page")) : 0;

  const { getEmployeeList } = useEmpList();
  const { employeeList } = state;
  const [search, setSearch] = useState(null);
  const [page, setPage] = useState(pageQuery);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalEmployeeCount, setTotalEmployeeCount] = useState(0);
  const [filteredResults, setFilteredResults] = useState([]);
  const [month, setMonth] = useState(null);
  const [loader, setLoader] = useState(false);
  const [date, setDate] = useState(null);
  const [disableButton, setDisableButton] = useState(false);
  const today = new Date();
  const [error, setError] = useState(null);
  const [error2, setError2] = useState(null);
  const [empId, setEmpId] = useState(null);
  const [employeeType, setEmployeeType] = useState("");
  const [workHours, setWorkHours] = useState("09:00:00"); 
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const isFirstRun = useRef(true);
  const [imageError, setImageError] = useState(false);
  const [statusFilter, setStatusFilter] = useState("");

  const [imgPath, setImgPath] = useState({
    img: "",
    id: "",
    name: "",
    inLoction: "",
    outLocation: "",
    OutImg: "",
    InImg: "",
  });

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setImgPath({
      img: "",
      id: "",
      name: "",
      inLoction: "",
      outLocation: "",
      OutImg: "",
      InImg: "",
    });
    setOpen(false);
  };

  const ExportToExcel = () => {
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    let formattedDate = "";
    if (moment(date, "YYYY-MM-DD", true).isValid()) {
      formattedDate = moment(date).format("DD-M-yyyy");
    }

    let formattedMonth = "";
    if (moment(month, "YYYY-MM", true).isValid()) {
      formattedMonth = moment(month).format("MM-yyyy");
    }

    const fileName = `Report_${search ? search : ""}_${formattedDate || formattedMonth}`;

    const exportToCSV = () => {
      setLoader(true);
      if (error === "invalidDate" || error2 === "invalidDate") {
        setLoader(false);
        return;
      }

      let params = {
        export: true,
        date: date || month,
        name: empId,
        employeeType: employeeType || undefined,
        status: statusFilter,
      };

      searchReport(params)
        .then((res) => {
          setLoader(false);
          if (res?.status === 200) {
            let exportData = res?.data?.data?.employeeAttendanceList?.map((object) => {
              const copy = { ...object };
              delete copy["checkInPath"];
              delete copy["checkOutPath"];
              return copy;
            });
const transformedExportData = exportData.map(
              (employee) => ({
                ID: employee.empId,
                Name: employee.firstName,
                Date: convertedDate(employee.date),
                Check_In_Time: employee.checkInTime,
                Check_Out_Time: employee.checkOutTime,
                total_work_hours: employee.totalWorkHours,
                Status: employee.status,
              })
            );
            const ws = XLSX.utils.json_to_sheet(transformedExportData);
            const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, fileName + fileExtension);
          } else {
            generateErrorMessage("Something went wrong.");
          }
        })
        .catch((error) => {
          setLoader(false);
          generateErrorMessage(`${error?.response?.data?.message || ""}`);
        });
    };

    return (
      <StyledButton
        variant="contained"
        color="primary"
        startIcon={<SaveAltIcon />}
        onClick={() => exportToCSV()}
        disabled={disableButton}
      >
        Export
      </StyledButton>
    );
  };

  const handleChangePage = (_e, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

const globalSearch = () => {
  setLoader(true);
  const params = {
    date: date || month,
    page: `${page + 1}`,
    limit: rowsPerPage,
    name: empId,
    employeeType: employeeType || undefined,
    status: statusFilter || undefined, // ✅ include status filter
  };

  searchReport(params)
    .then((res) => {
      setLoader(false);
      if (res?.status === 200) {
        setFilteredResults(res?.data?.data?.employeeAttendanceList);
        setTotalEmployeeCount(res?.data?.data?.totalCount);
        setDisableButton(res?.data?.data?.employeeAttendanceList?.length === 0);
      }
    })
    .catch((error) => {
      setLoader(false);
      generateErrorMessage(`${error?.response?.data?.message || ""}`);
    });
};


  useEffect(() => {
    globalSearch();
  }, [rowsPerPage, page, search, date, month, empId , statusFilter]);



useEffect(() => {
  setPage(0);
  globalSearch();
}, [employeeType]);

  useEffect(() => {
    getEmployeeList();
  }, []);

  const resetHandler = () => {
    setSearch(null);
    setDate(null);
    setMonth(null);
    setDisableButton(false);
    setEmpId(null);
    setStatusFilter("");
    setEmployeeType("");
    setFilteredResults([]);
  };

  useEffect(() => {
    if (search === null) {
      setEmpId(null);
    }
  }, [search]);

  const handleDateChange = (val) => {
    setPage(0);
    setMonth(null);
    setDisableButton(false);
    setDate(attendanceConvertedDate(val));
    setError2("");
  };

  const handleYearChange = (val) => {
    if (val) {
      setPage(0);
      setDate(null);
      setDisableButton(false);
      setError("");
      setMonth(convertedDateToMonthyearFormat2(val));
    } else {
      setMonth(null);
    }
  };

  useEffect(() => {
    const { hostname } = window.location;
    document.title = `${hostname} | Attendance Report`;
  }, []);



  return (
    <Container>
      <Paper elevation={2} sx={{ p: 2 }}>
        <AdminComplianceHeader
          employeeList={employeeList}
          search={search}
          setSearch={setSearch}
          setPage={setPage}
          disableButton={disableButton}
          setDisableButton={setDisableButton}
          setMonth={setMonth}
          setDate={setDate}
          error={error}
          error2={error2}
          setError2={setError2}
          setError={setError}
          month={month}
          date={date}
          setEmpId={setEmpId}
          employeeType={employeeType}
          setEmployeeType={setEmployeeType}
          today={today}
          handleOnlyDateChange={handleDateChange}
          handleMonthYearChange={handleYearChange}
          exportAction={<ExportToExcel />}
          resetAction={
            <StyledButton
              variant="outlined"
              color="primary"
              startIcon={<RestartAltIcon />}
              onClick={resetHandler}
            >
              Reset
            </StyledButton>
          }
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
        />
        <Box width="100%" overflow="auto">
          {filteredResults?.length > 0 ? (
            <Box width="100%" overflow="auto">
              <TableContainer>
                <StyledTable sx={{ minWidth: 870 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">ID</TableCell>
                      <TableCell align="center">Name</TableCell>
                      <TableCell align="center">Date</TableCell>
                      <TableCell align="center">In Picture</TableCell>
                      <TableCell align="center">Out Picture</TableCell>
                      <TableCell align="center">In-Time</TableCell>
                      <TableCell align="center">Out-Time</TableCell>
                      <TableCell align="center">Total Hour</TableCell>
                      <TableCell align="center">Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredResults?.map((employee, index) => (
                      <TableRow
                        key={`${index}+${employee.empId}+${employee.checkInPath}+${employee.checkOutPath}+${employee.checkInTime}+${employee.checkOutTime}+${employee.date}`}
                      >
                        <TableCell align="center">{employee?.empId || "_"}</TableCell>
                        <TableCell align="center">{employee?.firstName || "_"}</TableCell>
                        <TableCell align="center">{convertedDate(employee?.date) || "_"}</TableCell>
                        <TableCell
                          align="center"
                          onClick={(event) => {
                            if (
                              imageError ||
                              !employee?.checkInPath ||
                              event.currentTarget.style.pointerEvents === "none"
                            ) {
                              return;
                            }
                            handleOpen();
                            setImgPath({
                              img: employee?.checkInPath,
                              id: employee?.empId,
                              name: employee?.firstName,
                              inLoction: employee?.checkInLocation,
                              outLocation: employee?.checkOutLocation,
                              InImg: "Check-In Image",
                            });
                          }}
                        >
                          {employee?.checkInPath && !imageError ? (
                            <img
                              onError={(event) => {
                                setImageError(true);
                                event.target.style.display = "none";
                                event.currentTarget.parentElement.style.pointerEvents = "none";
                              }}
                              src={`${baseURL}${employee.checkInPath}`}
                              className="img-fluid"
                              style={{ height: "50px", width: "50px" }}
                              alt="Check In img"
                            />
                          ) : (
                            "--"
                          )}
                        </TableCell>
                        <TableCell
                          align="center"
                          onClick={(event) => {
                            if (
                              imageError ||
                              !employee?.checkOutPath ||
                              event.currentTarget.style.pointerEvents === "none"
                            ) {
                              return;
                            }

                            handleOpen();
                            setImgPath({
                              img: employee?.checkOutPath,
                              id: employee?.empId,
                              name: employee?.firstName,
                              inLoction: employee?.checkInLocation,
                              outLocation: employee?.checkOutLocation,
                              OutImg: "Check-Out Image",
                            });
                          }}
                        >
                          {employee?.checkOutPath && !imageError ? (
                            <img
                              onError={(event) => {
                                setImageError(true);
                                event.target.style.display = "none";
                                event.target.parentElement.style.pointerEvents = "none";
                              }}
                              src={`${baseURL}${employee.checkOutPath}`}
                              className="img-fluid"
                              style={{ height: "50px", width: "50px" }}
                              alt="Check Out img"
                            />
                          ) : (
                            "--"
                          )}
                        </TableCell>
                        <TableCell align="center">{employee?.checkInTime || "_"}</TableCell>
                        <TableCell align="center">{employee?.checkOutTime || "_"}</TableCell>
                        <TableCell align="center">{employee?.totalWorkHours || "_"}</TableCell>
                        <TableCell align="center">{employee?.status || "_"}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </StyledTable>
              </TableContainer>

              <TablePagination
                className="pagination-container"
                classes={{
                  select: "pagination-select",
                  actions: "pagination-actions",
                }}
                sx={{ px: 2 }}
                page={page}
                component="div"
                rowsPerPage={rowsPerPage}
                count={totalEmployeeCount}
                onPageChange={handleChangePage}
                rowsPerPageOptions={[10, 25, 50]}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Box>
          ) : (
            !loader && (
              <p
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                No data available!
              </p>
            )
          )}
        </Box>
        <EmpCard
          open={open}
          handleClose={handleClose}
          id={imgPath?.id}
          name={imgPath?.name}
          img={imgPath?.img}
          inLoction={imgPath?.inLoction}
          outLocation={imgPath?.outLocation}
          InImg={imgPath?.InImg}
          OutImg={imgPath?.OutImg}
        />
      </Paper>
      <BackdropLoader loader={loader} />
    </Container>
  );
};

export default Report;